// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { _ComplianceBanner } from './ComplianceBanner';
export type { _ComplianceBannerProps, _ComplianceBannerStrings } from './types';
